import { identity } from 'lodash/fp';
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { InputText, InputTextProps } from '../../../components/input';

export interface RHFInputTextProps extends InputTextProps {
  control: Control;
  setValueAs?: (value: any) => any;
}

/**
 * # [Controlled input wrapper](https://codesandbox.io/s/react-hook-form-controller-079xx)
 * */
export const RHFInputText = ({
  control,
  defaultValue,
  name,
  label,
  errors,
  InputProps,
  multiline,
  setValueAs = identity,
  ...restProps
}: RHFInputTextProps) => {
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  return (
    <Controller
      defaultValue={defaultValue || ''}
      name={name}
      control={control}
      onFocus={() => {
        inputRef.current?.focus();
      }}
      render={(controllerProps) => (
        <InputText
          multiline={multiline}
          InputProps={InputProps}
          errors={errors}
          label={label}
          {...restProps}
          {...controllerProps}
          value={
            controllerProps.value === null ? undefined : controllerProps.value
          }
          onChange={(event) =>
            controllerProps.onChange(setValueAs(event.target.value))}
          ref={inputRef}
        />
      )}
    />
  );
};
